import * as React from 'react'
import './banner-carousel.css'

interface IState {
  number: number
  name: string
  intervalid: any
}

export default class Banner extends React.Component<any, IState> {
  constructor(props: any) {
    super(props)
    this.state = {
      intervalid: 0,
      name: '',
      number: 0,
    }
    this.switcher = this.switcher.bind(this)
    this.changeSlide = this.changeSlide.bind(this)
  }

  componentDidMount() {
    const interval = setInterval(() => {
      const NewNumber = this.state.number === 4 ? 0 : this.state.number + 1
      this.setState({ number: NewNumber, name: this.switcher(NewNumber) })
    }, 5000)
    this.setState({ intervalid: interval })
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalid)
  }

  changeSlide(newSlideNumber: string) {
    clearInterval(this.state.intervalid)
    const newer = parseInt(newSlideNumber, 10)
    this.setState({
      name: this.switcher(newer),
      number: newer,
    })
  }
  switcher(newNumber: number) {
    let newName = ''
    switch (newNumber) {
      case 0:
        newName = ''
        break
      case 1:
        newName = 'second'
        break
      case 2:
        newName = 'third'
        break
      case 3:
        newName = 'fourth'
        break
      case 4:
        newName = 'fifth'
        break
      default:
        newName = ''
        break
    }
    return newName
  }

  render() {
    const { content } = this.props
    const sliderClass = 'banner-slider ' + this.state.name

    return (
      <div className="banner">
        <div className={sliderClass}>
          {content !== undefined &&
            Object.keys(
              content.sort((a: any, b: any) =>
                a.fields.order > b.fields.order
                  ? 1
                  : b.fields.order > a.fields.order
                  ? -1
                  : 0,
              ),
            ).map(key => {
              const image = {
                backgroundImage:
                  window.innerWidth > 768
                    ? `url(${content[key].fields.mynd.fields.file.url})`
                    : `url(${content[key].fields.mobile.fields.file.url})`,
              }
              return (
                <div key={key} className="banner-slider-image" style={image}>
                  <div className="scroll">
                    Skrunaðu <span className="arrow" />{' '}
                    <span className="arrow" /> <span className="arrow" />{' '}
                  </div>
                  <div className="banner-text-overlay">
                    <div className="banner-text-container item-container">
                      <h2>{content[key].fields.textiMeMynd}</h2>

                      <a href={content[key].fields.hlekkur}>Skoða nánar</a>
                    </div>
                  </div>
                </div>
              )
            })}
        </div>
        <div className="banner-lines">
          {content !== undefined &&
            Object.keys(content).map(key => {
              let correctClass = ''
              if (parseInt(key, 10) > this.state.number) {
                correctClass = 'banner-lines-line'
              } else if (parseInt(key, 10) === this.state.number) {
                correctClass = 'banner-lines-line active'
              } else {
                correctClass = 'banner-lines-line done'
              }

              return (
                <span
                  key={key}
                  className={correctClass}
                  onClick={this.changeSlide.bind(this, key)}
                />
              )
            })}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/front-page/banner-carousel/banner-carousel.tsx